module.exports = __webpack_public_path__ + "img/pinduoduo.3441359f.png";